<template>
    <div class="page">
        <div class="card">
            <van-card>
                <template #title>
                    <div class="s-title">{{ dataObj.shareName }}</div>
                </template>
                <template #price>
                    <div style="color: red;">{{showPrice}}/件</div>
                </template>
                <template #thumb>
                    <img :src="dataObj.img" alt="" style="width:90px;height:100px;">
                </template>
                <!-- <template #footer>
                    <van-button size="mini">
                        <van-icon name="minus" />
                    </van-button>
                    <div style="margin:0 10px">2</div>
                    <van-button size="mini">
                        <van-icon name="plus" />
                    </van-button>
                </template> -->
            </van-card>
        </div>
        <van-cell-group inset>
            <van-field v-model="dataFrom.pcaAddress" label="买家备注" maxlength="100" show-word-limit placeholder="请输入"
                input-align="right" />
        </van-cell-group>

        <van-cell-group inset style="margin:16px;">
            <van-field v-model="showPrice" label="商品小计" readonly input-align="right" />
            <van-field v-model="shipping" label="运费" readonly input-align="right" />
            <van-field v-model="jifen" label="购物积分" readonly input-align="right" />
        </van-cell-group>

        <van-cell-group inset>
            <van-field v-model="dataFrom.takeNickname" label="收获姓名" placeholder="请输入" input-align="right" />
            <van-field v-model="dataFrom.takePhone" label="收获手机号" type="tel" placeholder="请输入" input-align="right" />
            <van-field v-model="dataFrom.takeAddress" label="收获地址" placeholder="请输入" input-align="right" />
        </van-cell-group>
        <van-submit-bar :loading="false" text-align="left" :price="smallTotal" button-text="提交订单" @submit="onSubmit" />


        
        <br/>
        <br/>
        <div class="content">
            <div class="c-fl">
                <div class="name">品牌</div>
                <div class="n-k">{{dataObj.name}}</div>
            </div>
            <div class="c-fl">
                <div class="name">型号</div>
                <div class="n-k">{{dataObj.name1}}</div>
            </div>
            <div class="c-fl">
                <div class="name">是否无线</div>
                <div class="n-k">{{dataObj.name2}}</div>
            </div>
            <div class="c-fl">
                <div class="name">无线传输速度</div>
                <div class="n-k">{{dataObj.name3}}</div>
            </div>
            <div class="c-fl">
                <div class="name">是否可拆</div>
                <div class="n-k">{{dataObj.name4}}</div>
            </div>
            <div class="c-fl">
                <div class="name">无线网络支持频率</div>
                <div class="n-k">{{dataObj.name5}}</div>
            </div>
            <div class="c-fl">
                <div class="name">适用对象</div>
                <div class="n-k">{{dataObj.name6}}</div>
            </div>
            <div class="c-fl">
                <div class="name">有线传输率</div>
                <div class="n-k">{{dataObj.name7}}</div>
            </div>
            <!-- <div class="c-fl">
                <div class="name">套餐类型</div>
                <div class="n-k">{{dataObj.name8}}</div>
            </div> -->
        </div>
        <img :src="dataObj.imga" alt="" >
        <img :src="dataObj.imgb" alt="" >
        <div class="copyright">
            <div class="top">深圳市雁云信息技术有限公司</div>
            <div class="top">备案号：粤ICP备19128032号-1</div>
        </div>
    </div>
</template>
<script>
import { Toast,Dialog } from 'vant';
import { wxRequest } from '@/api/user'
export default {
    data() {
        return {
            dataObj:{},
            jifen:'0',
            value: '',
            smallTotal: '',
            shipping: '￥0.00',
            showPrice: '',
            dataFrom: {
                otherData:"ydai",
                oldIccid: '新设备页面购买',
                takeNickname: '',
                takePhone: '',
                takeAddress: '',
                changeCmccSim: '1', 
                applyType: '1',
                pcaAddress: '',
                idCard: '',
                callback: '', 
                buyPrice:'',
            },
        }
    },
    created(){
      this.dataObj = JSON.parse(decodeURI(this.$route.query.p))
      this.smallTotal=this.dataObj.sharePrice * 100;
      this.showPrice="￥"+this.dataObj.sharePrice;
      console.log(this.dataObj)
    },
    methods: {
        // 提交数据 
        onSubmit() {
            this.dataFrom.buyPrice = this.dataObj.sharePrice;
            wxRequest('applyChangeSim/apply/sim/my/pay', this.dataFrom, 'post').then(res => {
                if (res.data.code == 200) {
                    window.location.href = res.data.data;
                } else {
                    Toast.fail(res.data.message);
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
.page {
    min-height: 100%;
    flex-direction: column;
    width: 100%;
    display: flex;
    background: #f5f5f5;
    padding-bottom: 36px;
    .card {
        width: 90%;
        margin: 14px auto;

        .van-card {
            border-radius: 13px;
            background: #fff;

            .s-title {
                font-size: 18px;
                margin-top: 10px;
                font-weight: bold;
            }

            .van-card__price {
                font-size: 16px;
                font-weight: bold;
            }

            .van-card__footer {
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }
        }
    }
}
.content{
    margin:16px;
    background: #fff;
    border-radius: 13px;
    .c-fl{
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eeeeee;
        .name{
            width:84px;
            padding:12px 20px;
            box-sizing: content-box;
            line-height: 20px;
            font-size:14px;
            background: #e6e5e5;
            
        }
        &:nth-child(1){
            .name{ 
                border-top-left-radius: 13px;
            };
        }
        &:nth-child(9){
            .name{ 
                border-bottom-left-radius: 12px
            };
        }
        .n-k{
            padding:12px 20px;
            font-size:14px;
            line-height: 20px;
        }
    }
}
.copyright{
    text-align: center;
    padding:14px 0;
    font-size:14px;
    .top{
        margin-bottom:12px;
    }
}
</style>